import React, {useState, useEffect, useContext} from 'react';
import { connect } from "react-redux";
//import { withRouter } from "react-router";
import { Icon, Image, List, Button} from 'semantic-ui-react';
import './BankCardsList.css';

import GlobalContext from '../../contexts/GlobalContext';
import ModalContext from '../../contexts/ModalContext';
import API, {ErrorManagement, ResponseManagement} from "../../API";
import Utility from "../../Utility";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import ModalConfirmDeleteBankCard from "./Modal/ModalConfirmDeleteBankCard";
import ModalConfirmUpdateBankCard from "./Modal/ModalConfirmUpdateBankCard";
import bank from "../../store/bank";


const mapProps = (state) => ({
  bankCards: state.bank.cards,
});

const mapDispatch = (dispatch) => ({
  loadBankCards: dispatch.bank.load,
  addBankCard: dispatch.bank.addCardAsync,
  updateBankCard: dispatch.bank.updateCardAsync,
  removeBankCard: dispatch.bank.removeCardAsync,
  handleRedirectType: dispatch.authentication.handleRedirectType
});

export const UsingLogo = ({using, isForCardHandler, translatedLabel}) => {
  let classColor = using === 'prestay' ? 'blue' : using === 'stay' ? 'yellow' : '';
  let classSize = isForCardHandler ? "" : "mini";
  let classToRender = "ui " + classSize + " " + classColor + " label";

  return <div key={using} className={classToRender}>{translatedLabel}</div>;
};

export const UsingButton = ({using, bankCard, onSetUseClick, handleRedirectType, translations}) => {
  return (
    using === 'prestay' ?
      <Button className="setUseActionPrestay" size="mini" compact content={translations.setBankCardPrimary} onClick= {() => {handleRedirectType(() => {onSetUseClick(bankCard, 'prestay')})}} />
    :
      <Button className="setUseActionStay" size="mini" compact content={translations.setBankCardExtra} onClick= {() => {handleRedirectType(() => {onSetUseClick(bankCard, 'stay')})}} />
  );
};

export const BankCardItem = ({bankCard, index, isForBankCardsHandler, onSetUseClick, handleRedirectType, translations}) => {
  let useLogos = [];
  let useButtons = [];
  if (bankCard.prestay && bankCard.stay) {
    useLogos.push(<UsingLogo key={"prestayLogo"+index} using="prestay" isForCardHandler={isForBankCardsHandler} translatedLabel={translations.primary}/>)
    useLogos.push(<UsingLogo key={"stayLogo+"+index} using="stay" isForCardHandler={isForBankCardsHandler} translatedLabel={translations.extra}/>)
  } else if (!bankCard.prestay && bankCard.stay) {
    useLogos.push(<UsingLogo key={"stayLogo"+index} using="stay" isForCardHandler={isForBankCardsHandler} translatedLabel={translations.extra}/>)
    useButtons.push(<UsingButton key={"prestayButton"+index} using="prestay" bankCard={bankCard} onSetUseClick={onSetUseClick} handleRedirectType={handleRedirectType} translations={translations}/>)
  } else if (bankCard.prestay && !bankCard.stay) {
    useLogos.push(<UsingLogo key={"prestayLogo"+index} using="prestay" isForCardHandler={isForBankCardsHandler} translatedLabel={translations.primary}/>)
    useButtons.push(<UsingButton key={"stayButton"+index} using="stay" bankCard={bankCard} onSetUseClick={onSetUseClick} handleRedirectType={handleRedirectType} translations={translations}/>)
  } else {
    useButtons.push(<UsingButton key={"prestayButton"+index} using="prestay" bankCard={bankCard} onSetUseClick={onSetUseClick} handleRedirectType={handleRedirectType} translations={translations}/>)
    useButtons.push(<UsingButton key={"stayButton"+index} using="stay" bankCard={bankCard} onSetUseClick={onSetUseClick} handleRedirectType={handleRedirectType} translations={translations}/>)
  }

  return (
    isForBankCardsHandler ?
      <>
        <List.Item className={"ui message div-message-custom"} key={index}>
          <div className="inner-content">
            <Image src={bankCard.logo} rounded className="image-custom"/>
            <div className="custom-list-description card-number">
              <div className="card-holder">{bankCard.name}</div>
              <div>{bankCard.number}</div>
              <div>{bankCard.expirationMonth}/{bankCard.expirationYear}</div>
            </div>
          </div>

          <div className="inner-content">
            {useLogos}
          </div>

          <div className="inner-content">
            {useButtons}
          </div>

          {/*<Icon className={"delete-icon " + classNameDeleteButton} name='delete' color='red' size='large' onClick={() => {
                  setItemToRemove({id: props.bankCards[i].id, bookingFolderId: props.bankCards[i].bookingFolderId});
                  setShowModalDeleteBankCardState(true)
                }}
                />*/}
        </List.Item>

        {bankCard.prestay ? <List.Item><hr/></List.Item> : null}
      </>
    :
      <List.Item className={"ui message div-message-custom-dashboard"} key={index}>
        <div className="inner-content">
          <Image src={bankCard.logo} rounded className="image-custom"/>
          <div className="custom-list-description">
            <div className="card-holder">{bankCard.name}</div>
            <div className="card-number">{bankCard.number}</div>
            <div className="useLogosContainer">{useLogos}</div>
          </div>
        </div>
      </List.Item>
  );
}

const GetBankCardsList = connect(null, mapDispatch)(({bankCards, isForBankCardsHandler, onSetUseClick, bankModuleId, bookingFolderId, loadBankCards, handleRedirectType, translations}) => {
  const {setModalIsOpen} = useContext(ModalContext);
  let bankCardsList = [];
  let numberBankCardToDisplay = isForBankCardsHandler ? bankCards.length : bankCards.length >= 2 ? 2 : bankCards.length;

  const addCardSuccess = () => {
    loadBankCards({
      bookingFolderId: bookingFolderId,
      active: "1",
      bankModuleId: bankModuleId,
      virtualCard: false
    })

    setModalIsOpen(false)
  }

  const addCardFailed = (e) => {
    // toast.error( translations[response.data.message] );
    toast.error( translations.addBankCardError );
  }

  for (let i=0; i < numberBankCardToDisplay; i++) {
    bankCardsList.push(
      <BankCardItem bankCard={bankCards[i]} key={i} index={i} isForBankCardsHandler={isForBankCardsHandler} handleRedirectType={handleRedirectType} onSetUseClick={onSetUseClick} translations={translations}/>
    );
  }

  return (
    <List>
      <input type="hidden" id="tokenize-success" onClick={addCardSuccess} />
      <input type="hidden" id="tokenize-failed" onClick={addCardFailed} />
      {bankCardsList}
    </List>
  );
})

/**
 * Components BankCardsList
 * Widget pour le dashboard
 */
const BankCardsList = props => {
  const [showModalUpdateBankCardState, setShowModalUpdateBankCardState] = useState(false);
  // const [showModalDeleteBankCardState, setShowModalDeleteBankCardState] = useState(false);
  // const [isConfimDelete, setIsConfimDelete] = useState(false);
  const [isConfirmUpdate, setIsConfirmUpdate] = useState(false);
  const [itemToRemove, setItemToRemove] = useState({});
  const [itemToUpdate, setItemToUpdate] = useState({});

  const [globalContext] = useContext(GlobalContext);
  const siteMap = Utility.getSiteMap(globalContext.translations);

  // const handleConfirmDelete = () => {
  //   setIsConfimDelete(true);
  // };
  // const onConfirmDelete = () => {
  //   props.removeBankCard({data: itemToRemove, tradDisableSuccess: globalContext.translations.successBankCardDeletion});
  // };

  const handleConfirmUpdate = () => {
    setIsConfirmUpdate(true);
  }



  const onSetUseClick = (bankCard, use) => {
    let stay = use === 'stay';
    let prestay = use === 'prestay';

    setItemToUpdate({id: bankCard.id, bankCard: bankCard, bookingFolderId: bankCard.bookingFolderId, prestay: prestay, stay: stay});
    setShowModalUpdateBankCardState(true)
  }


  const onSetUseConfirm = () => {
    props.updateBankCard(itemToUpdate)
  };

  const getWarningNoCreditCard = () => {
    return (
      <div className="no-credit-card-warning">
        <Icon as="i" name='warning sign' size='huge' color='red'/>
        <h3>{globalContext.translations.compromisedBooking}</h3>
        <p>{globalContext.translations.noBankCardSet}.</p>
      </div>
    )
  };


  return (
    <div>
      {/*<ModalConfirmDeleteBankCard
        open={showModalDeleteBankCardState}
        handleConfimDelete={handleConfirmDelete}
        setIsConfimDelete={setIsConfimDelete}
        onConfirm={onConfirmDelete}
        handleClose={() => { setShowModalDeleteBankCardState(false) }}
      />*/}
      <ModalConfirmUpdateBankCard
        open={showModalUpdateBankCardState}
        handleConfirmUpdate={handleConfirmUpdate}
        setIsConfimUpdate={setIsConfirmUpdate}
        onConfirm={onSetUseConfirm}
        bankCardConfimUsing={itemToUpdate.prestay ? 'prestay' : itemToUpdate.stay ? 'stay' : ""}
        handleClose={() => { setShowModalUpdateBankCardState(false) }}
      />
      {props.bankCards.length !== 0 ? <GetBankCardsList bankCards={props.bankCards} isForBankCardsHandler={props.isForBankCardsHandler} handleRedirectType={props.handleRedirectType} onSetUseClick={onSetUseClick} bankModuleId={globalContext.establishment.bankModuleInfos.bankModuleId} bookingFolderId={props.match.params.id} translations={globalContext.translations}/> : getWarningNoCreditCard()}
    </div>
  );
}

export default connect(mapProps, mapDispatch)(BankCardsList);